<template>
  <v-dialog persistent v-model="value" max-width="290">
    <v-form @submit.prevent="save">
      <v-card>
          <v-card-title class="headline">{{partner ? $t('Pages.Partners.update') : $t('Pages.Partners.add_new')}}</v-card-title>

          <v-card-text>
            <v-layout column wrap>
              <v-flex xs12 md5>
                <v-combobox
                  :search-input.sync="qUser"
                  v-model="newPartner.user"
                  :items="users"
                  :loading="userLoading"
                  v-validate="'required'"
                  :error-messages="errors.first('name')"
                  name="name"
                  item-text="profile.name"
                  color="indigo"
                  hide-selected
                  :label="$t('Pages.Partners.title_singular')"
                  :placeholder="$t('Common.type_to_search')"
                  prepend-icon="mdi-account-group"
                >
                  <template slot="selection" slot-scope="{ item }">
                    <v-chip>
                      <span class="pr-2">
                        {{ item.profile ? item.profile.name : newPartner.user }}
                      </span>
                      <v-icon
                        small
                        @click.stop="remove()"
                      >close</v-icon>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-validate="'required'"
                  v-model="newPartner.pib"
                  :error-messages="errors.first('pib')"
                  :label="$t('Pages.Partners.model.pib')"
                  type="text"
                  name="pib"
                />
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-model="newPartner.mbr"
                  :label="$t('Pages.Partners.model.mbr')"
                  type="text"
                  name="mbr"
                />
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-validate="'required'"
                  v-model="newPartner.city"
                  :error-messages="errors.first('city')"
                  :label="$t('Pages.Partners.model.city')"
                  type="text"
                  name="city"
                />
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field
                  v-model="newPartner.address"
                  :error-messages="errors.first('address')"
                  :label="$t('Pages.Partners.model.address')"
                  type="text"
                  name="address"
                />
              </v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="close">
                {{$t('Core.Fields.close')}}
            </v-btn>

            <v-btn dark color="success dark1" type="submit">
                {{$t('Core.Fields.save')}}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';
  import _ from 'lodash';
  export default {
    props: ['value', 'partner'],
    data: () => ({
      newPartner: {},
      qUser: null,
      users: [],
      userLoading: false,
    }),
    computed: {
      ...mapState('app', ['me']),
    },
    methods: {
      close(){
        this.newPartner = {};
        this.$emit('close')
        this.$validator.reset()
      },
      save(){
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (this.newPartner.user.profile) {
                this.newPartner.name = this.newPartner.user.profile.name;
            } else {
                this.newPartner.name = this.newPartner.user;
            }
            if(!this.partner) {
              this.repositories.partner.store(this.newPartner)
                .then(response => {
                  this.$toast.success(response.data.message);
                  this.newPartner = {};
                  this.$emit('refresh', response.data.data);
                  this.close();
                });
            } else {
              this.repositories.partner.update(this.newPartner.id, this.newPartner)
                .then(response => {
                  this.$toast.success(response.data.message);
                  this.newPartner = {};
                  this.$emit('refresh');
                  this.close();
                });
            }
          }
        });
      },
      remove() {
        delete this.newPartner.user;
        delete this.newPartner.pib;
        this.newPartner = { ...this.newPartner };
      }
    },
    watch: {
      'value': function() {
        if(this.value && this.partner) {
          this.newPartner = { ...this.partner };
        }
      },
      qUser: _.debounce(function(val){
        if(!val) return;
        // Items have already been loaded
        if (val.length < 3) return;

        // Items have already been requested
        if (this.userLoading) return;

        this.userLoading = true;
        this.repositories.user.all(val).then((response) => {
          this.users = response.data.data;
        }).finally(() => {
          this.userLoading = false;
        });
      }, 500),
      'newPartner.user': function(val) {
        if(this.value && this.newPartner.user && typeof val === 'object') {
          this.newPartner.pib = val.barcode;
        }
      },
    }
  }
</script>

<style lang="scss">

</style>